import { useState } from "react";
import { Button, Card, ErrorNote, Icon } from "./components";
import { AVV_ABSAETZE, AVV_TITEL, AVV_UNTERTITEL, avvAlsPdfDrucken } from "../lib/avv-support-zugriff";

export function AvvPdfKnopf({ betrieb, label, variant = "secondary" }: { betrieb: string; label: string; variant?: "primary" | "secondary" }) {
  const [fehler, setFehler] = useState<string | null>(null);
  return (
    <>
      <Button
        variant={variant}
        type="button"
        onClick={() => setFehler(avvAlsPdfDrucken(betrieb) ? null : "Das Druckfenster wurde vom Browser blockiert. Bitte Pop-ups für diese Seite erlauben.")}
      >
        <Icon name="download" className="text-[18px]" />
        {label}
      </Button>
      {fehler && <ErrorNote message={fehler} />}
    </>
  );
}

/** Einstellungen → Datenschutz: Karte „Support-Zugriffe“ samt Zwischenüberschrift. */
export function AvvSupportZugriffKarte({ betrieb }: { betrieb: string }) {
  return (
    <>
      <p className="pt-2 font-label-md text-label-md font-semibold uppercase tracking-wider text-secondary dark:text-secondary-fixed-dim">
        Ihr Vertrag mit MAESTRO
      </p>
      <Card className="p-6" data-testid="avv-support-karte">
        <div className="mb-4 flex flex-wrap items-start justify-between gap-3">
          <div className="flex items-center gap-3">
            <Icon name="support_agent" className="text-[24px] text-primary" />
            <div>
              <h3 className="font-headline-sm text-headline-sm font-bold text-on-background dark:text-inverse-on-surface">{AVV_TITEL}</h3>
              <p className="font-body-sm text-body-sm text-secondary dark:text-secondary-fixed-dim">{AVV_UNTERTITEL}</p>
            </div>
          </div>
          <AvvPdfKnopf betrieb={betrieb} label="Als PDF herunterladen" />
        </div>
        <div className="space-y-3.5 font-body-md text-body-md text-on-background dark:text-inverse-on-surface">
          {AVV_ABSAETZE.map((a) => (
            <p key={a.stichwort}>
              <strong>{a.stichwort}</strong> {a.text}
            </p>
          ))}
        </div>
      </Card>
    </>
  );
}
